import { Empty, Upload as AntUpload } from 'antd'
import { UploadFile } from 'antd/lib/upload/interface'
import React, { FC } from 'react'
import { useDispatch } from 'react-redux'
import { alertActions } from '../../../store/slices/alertSlice'
import { getAcceptFormats } from '../../../utils/getAcceptFormat'
import { Text } from '../../common/text'
import FilePreview from '../file-preview/file-preview'
import { TooltipHelper } from '../index'
import './upload.ant.scss'
import { UploadFormat, validateUploadFiles } from './validate-upload-files'

type UploadProps = {
  maxFiles?: number
  files: UploadFile[]
  onUploadFileAdd: (files: UploadFile[]) => void
  onRemoveFile: (uid: string) => void
  tooltipDescription?: string
  withoutVideo?: boolean
  formatFiles?: UploadFormat
  hideUploadFieldWhenFilesAdded?: boolean
  hideUploadField?: boolean
}

const Upload: FC<UploadProps> = (props) => {
  const {
    onUploadFileAdd,
    onRemoveFile,
    files,
    tooltipDescription,
    withoutVideo,
    formatFiles,
    hideUploadFieldWhenFilesAdded,
    hideUploadField,
    maxFiles,
  } = props

  const dispatch = useDispatch()

  const onChange = ({ fileList }: { fileList: UploadFile[] }) => {
    const result = validateUploadFiles(fileList, { formatFiles, withoutVideo, maxFiles })
    result.warnings.forEach((message) => dispatch(alertActions.pushAlert({ message, severity: 'warning' })))
    onUploadFileAdd(result.files)
  }

  return (
    <AntUpload.Dragger
      accept={getAcceptFormats(formatFiles || 'all')}
      name="files"
      listType="picture"
      fileList={files}
      onChange={onChange}
      multiple={true}
      className={[
        'drag-and-drop',
        hideUploadField || (hideUploadFieldWhenFilesAdded && files.length) ? 'hide-upload-field' : '',
      ]
        .filter(Boolean)
        .join(' ')}
      // TODO странный callback ? зачем он нужен?
      // странность заключается в API ant'а, которое предлагает нам передавать в этот пропс колбэк,
      // возвращающий false, чтобы отменить POST запрос из компонента, т.к. мы постим файлы сами и позже
      // и POST из компонента нам не нужен.
      beforeUpload={() => false}
      itemRender={(originNode, file) => (
        <FilePreview
          key={file.uid}
          name={file.name}
          thumbScr={file.thumbUrl}
          type={file.type}
          url={
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            file.url || URL.createObjectURL(file.originFileObj ?? '')
          }
          onRemove={() => onRemoveFile(file.uid)}
          status={1}
          unclickable
        />
      )}
    >
      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={'Перетащите файлы сюда'} />
      <div className="upload-bottom">
        <Text className="upload-bottom-text">+ Добавить файлы</Text>
        {tooltipDescription && <TooltipHelper description={tooltipDescription} />}
      </div>
    </AntUpload.Dragger>
  )
}

export default Upload
